import { ENVIRONMENT_INITIALIZER, inject, ModuleWithProviders, NgModule } from '@angular/core';
import { IonicStorageModule, Storage, StorageConfig } from '@ionic/storage-angular';

@NgModule()
export class StorageModule {
  static forRoot(config?: StorageConfig): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: [
        ...IonicStorageModule.forRoot(config).providers!,
        {
          provide: ENVIRONMENT_INITIALIZER,
          useValue: () => inject(Storage).create(),
          multi: true,
        },
      ],
    };
  }
}
